/* Options:
Date: 2026-01-22 14:15:20
Version: 8.10
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:8668

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: immerable:immer
*/

import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IPost
{
}

export interface IPut
{
}

export interface IDelete
{
}

export interface IGet
{
}

export enum ConfigurationStatus
{
    Disabled = 1,
    ReadOnly = 2,
    Enabled = 3,
}

export enum SourceDataAllocationType
{
    Constant = 1,
    FirstXParticipants = 2,
    RepeatingCycle = 3,
    Inherit = 4,
    FirstXParticipantsAndRepeatingCycle = 5,
}

// @DataContract
export class ConfigurationCoordinatingGroup implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public name: string;

    // @DataMember(Order=6)
    public status?: ConfigurationStatus;

    // @DataMember(Order=7)
    public alertInformation: string;

    // @DataMember(Order=8)
    public alertWarning: string;

    // @DataMember(Order=9)
    public alertError: string;

    // @DataMember(Order=10)
    public alertSuccess: string;

    // @DataMember(Order=11)
    public allocationType?: SourceDataAllocationType;

    // @DataMember(Order=12)
    public enteredDate?: string;

    // @DataMember(Order=13)
    public enteredBy: string;

    // @DataMember(Order=14)
    public modifiedDate?: string;

    // @DataMember(Order=15)
    public modifiedBy: string;

    public constructor(init?: Partial<ConfigurationCoordinatingGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationSourceDataAllocation implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @References("typeof(SourceDataVerification.ServiceLogic.Models.Do.ConfigurationTrial)")
    public configurationTrialId?: number;

    // @DataMember(Order=3)
    // @References("typeof(SourceDataVerification.ServiceLogic.Models.Do.ConfigurationMasterGroup)")
    public configurationMasterGroupId?: number;

    // @DataMember(Order=4)
    // @References("typeof(SourceDataVerification.ServiceLogic.Models.Do.ConfigurationCoordinatingGroup)")
    public configurationCoordinatingGroupId?: number;

    // @DataMember(Order=5)
    // @References("typeof(SourceDataVerification.ServiceLogic.Models.Do.ConfigurationInstitution)")
    public configurationInstitutionId?: number;

    // @DataMember(Order=6)
    // @References("typeof(SourceDataVerification.ServiceLogic.Models.Do.ConfigurationParticipant)")
    public configurationParticipantId?: number;

    // @DataMember(Order=7)
    // @References("typeof(SourceDataVerification.ServiceLogic.Models.Do.ConfigurationSourceData)")
    public configurationSourceDataId?: number;

    // @DataMember(Order=8)
    public trialId?: number;

    // @DataMember(Order=9)
    public masterGroupId?: number;

    // @DataMember(Order=10)
    public coordinatingGroupId?: number;

    // @DataMember(Order=11)
    public institutionId?: number;

    // @DataMember(Order=12)
    public participantId?: number;

    // @DataMember(Order=13)
    public order?: number;

    // @DataMember(Order=14)
    public enteredDate?: string;

    // @DataMember(Order=15)
    public enteredBy: string;

    // @DataMember(Order=16)
    public modifiedDate?: string;

    // @DataMember(Order=17)
    public modifiedBy: string;

    // @DataMember(Order=18)
    public type?: SourceDataAllocationType;

    public constructor(init?: Partial<ConfigurationSourceDataAllocation>) { (Object as any).assign(this, init); }
}

export enum SourceDataAllocationSource
{
    Trial = 1,
    MasterGroup = 2,
    CoordinatingGroup = 3,
    Institution = 4,
    Participant = 5,
}

// @DataContract
export class ParticipantSourceDataAllocation
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public configurationSourceDataId?: number;

    // @DataMember(Order=8)
    public source?: SourceDataAllocationSource;

    public constructor(init?: Partial<ParticipantSourceDataAllocation>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ParticipantSourceDataAllocationUpdate
{
    [immerable] = true;
    // @DataMember(Order=1)
    public update?: boolean;

    // @DataMember(Order=2)
    public existingAllocation: ParticipantSourceDataAllocation;

    // @DataMember(Order=3)
    public newAllocation: ParticipantSourceDataAllocation;

    public constructor(init?: Partial<ParticipantSourceDataAllocationUpdate>) { (Object as any).assign(this, init); }
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy: string;
    modifiedDate?: string;
    modifiedBy: string;
}

export interface IQueryDataRequest
{
}

// @DataContract
export class ConfigurationInstitution implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public name: string;

    // @DataMember(Order=7)
    public status?: ConfigurationStatus;

    // @DataMember(Order=8)
    public alertInformation: string;

    // @DataMember(Order=9)
    public alertWarning: string;

    // @DataMember(Order=10)
    public alertError: string;

    // @DataMember(Order=11)
    public alertSuccess: string;

    // @DataMember(Order=12)
    public allocationType?: SourceDataAllocationType;

    // @DataMember(Order=13)
    public enteredDate?: string;

    // @DataMember(Order=14)
    public enteredBy: string;

    // @DataMember(Order=15)
    public modifiedDate?: string;

    // @DataMember(Order=16)
    public modifiedBy: string;

    public constructor(init?: Partial<ConfigurationInstitution>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationMasterGroup implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public name: string;

    // @DataMember(Order=5)
    public status?: ConfigurationStatus;

    // @DataMember(Order=6)
    public alertInformation: string;

    // @DataMember(Order=7)
    public alertWarning: string;

    // @DataMember(Order=8)
    public alertError: string;

    // @DataMember(Order=9)
    public alertSuccess: string;

    // @DataMember(Order=10)
    public allocationType?: SourceDataAllocationType;

    // @DataMember(Order=11)
    public enteredDate?: string;

    // @DataMember(Order=12)
    public enteredBy: string;

    // @DataMember(Order=13)
    public modifiedDate?: string;

    // @DataMember(Order=14)
    public modifiedBy: string;

    public constructor(init?: Partial<ConfigurationMasterGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationParticipant implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public name: string;

    // @DataMember(Order=8)
    public status?: ConfigurationStatus;

    // @DataMember(Order=9)
    public alertInformation: string;

    // @DataMember(Order=10)
    public alertWarning: string;

    // @DataMember(Order=11)
    public alertError: string;

    // @DataMember(Order=12)
    public alertSuccess: string;

    // @DataMember(Order=13)
    public allocationType?: SourceDataAllocationType;

    // @DataMember(Order=14)
    public enteredDate?: string;

    // @DataMember(Order=15)
    public enteredBy: string;

    // @DataMember(Order=16)
    public modifiedDate?: string;

    // @DataMember(Order=17)
    public modifiedBy: string;

    public constructor(init?: Partial<ConfigurationParticipant>) { (Object as any).assign(this, init); }
}

export enum SourceDataPriority
{
    Low = 1,
    Normal = 2,
    High = 3,
    Critical = 4,
    Inherit = 5,
}

export enum SourceDataEventStatus
{
    None = 1,
    Started = 2,
    Complete = 3,
    Skipped = 4,
    Locked = 5,
}

// @DataContract
export class ConfigurationSourceDataEvent implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public configurationSourceDataId?: number;

    // @DataMember(Order=4)
    public studyEventOid: string;

    // @DataMember(Order=5)
    public enabled?: boolean;

    // @DataMember(Order=6)
    public linked?: boolean;

    // @DataMember(Order=7)
    public priority?: SourceDataPriority;

    // @DataMember(Order=8)
    public name: string;

    // @DataMember(Order=9)
    public alertInformation: string;

    // @DataMember(Order=10)
    public alertWarning: string;

    // @DataMember(Order=11)
    public alertError: string;

    // @DataMember(Order=12)
    public alertSuccess: string;

    // @DataMember(Order=13)
    public statuses: SourceDataEventStatus[];

    // @DataMember(Order=14)
    public allowNotes?: boolean;

    // @DataMember(Order=15)
    public enteredDate?: string;

    // @DataMember(Order=16)
    public enteredBy: string;

    // @DataMember(Order=17)
    public modifiedDate?: string;

    // @DataMember(Order=18)
    public modifiedBy: string;

    // @DataMember(Order=19)
    public allowReview?: boolean;

    // @DataMember(Order=20)
    public allowVerification?: boolean;

    public constructor(init?: Partial<ConfigurationSourceDataEvent>) { (Object as any).assign(this, init); }
}

export enum SourceDataFormStatus
{
    None = 1,
    Started = 2,
    Complete = 3,
    Skipped = 4,
}

// @DataContract
export class ConfigurationSourceDataForm implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public configurationSourceDataId?: number;

    // @DataMember(Order=4)
    public studyEventOid: string;

    // @DataMember(Order=5)
    public caseReportFormOid: string;

    // @DataMember(Order=6)
    public enabled?: boolean;

    // @DataMember(Order=7)
    public linked?: boolean;

    // @DataMember(Order=8)
    public priority?: SourceDataPriority;

    // @DataMember(Order=9)
    public name: string;

    // @DataMember(Order=10)
    public alertInformation: string;

    // @DataMember(Order=11)
    public alertWarning: string;

    // @DataMember(Order=12)
    public alertError: string;

    // @DataMember(Order=13)
    public alertSuccess: string;

    // @DataMember(Order=14)
    public statuses: SourceDataFormStatus[];

    // @DataMember(Order=15)
    public allowNotes?: boolean;

    // @DataMember(Order=16)
    public enteredDate?: string;

    // @DataMember(Order=17)
    public enteredBy: string;

    // @DataMember(Order=18)
    public modifiedDate?: string;

    // @DataMember(Order=19)
    public modifiedBy: string;

    // @DataMember(Order=20)
    public allowReview?: boolean;

    // @DataMember(Order=21)
    public allowVerification?: boolean;

    public constructor(init?: Partial<ConfigurationSourceDataForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationSourceDataFormVersion implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public configurationSourceDataId?: number;

    // @DataMember(Order=4)
    public studyEventOid: string;

    // @DataMember(Order=5)
    public caseReportFormOid: string;

    // @DataMember(Order=6)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=7)
    public enabled?: boolean;

    // @DataMember(Order=8)
    public linked?: boolean;

    // @DataMember(Order=9)
    public priority?: SourceDataPriority;

    // @DataMember(Order=10)
    public name: string;

    // @DataMember(Order=11)
    public alertInformation: string;

    // @DataMember(Order=12)
    public alertWarning: string;

    // @DataMember(Order=13)
    public alertError: string;

    // @DataMember(Order=14)
    public alertSuccess: string;

    // @DataMember(Order=15)
    public enteredDate?: string;

    // @DataMember(Order=16)
    public enteredBy: string;

    // @DataMember(Order=17)
    public modifiedDate?: string;

    // @DataMember(Order=18)
    public modifiedBy: string;

    // @DataMember(Order=19)
    public allowReview?: boolean;

    // @DataMember(Order=20)
    public allowVerification?: boolean;

    public constructor(init?: Partial<ConfigurationSourceDataFormVersion>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationSourceDataItemGroup implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public configurationSourceDataId?: number;

    // @DataMember(Order=4)
    public studyEventOid: string;

    // @DataMember(Order=5)
    public caseReportFormOid: string;

    // @DataMember(Order=6)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=7)
    public itemGroupName: string;

    // @DataMember(Order=8)
    public enabled?: boolean;

    // @DataMember(Order=9)
    public linked?: boolean;

    // @DataMember(Order=10)
    public priority?: SourceDataPriority;

    // @DataMember(Order=11)
    public name: string;

    // @DataMember(Order=12)
    public alertInformation: string;

    // @DataMember(Order=13)
    public alertWarning: string;

    // @DataMember(Order=14)
    public alertError: string;

    // @DataMember(Order=15)
    public alertSuccess: string;

    // @DataMember(Order=16)
    public enteredDate?: string;

    // @DataMember(Order=17)
    public enteredBy: string;

    // @DataMember(Order=18)
    public modifiedDate?: string;

    // @DataMember(Order=19)
    public modifiedBy: string;

    // @DataMember(Order=20)
    public allowReview?: boolean;

    // @DataMember(Order=21)
    public allowVerification?: boolean;

    public constructor(init?: Partial<ConfigurationSourceDataItemGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationSourceDataItem implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public configurationSourceDataId?: number;

    // @DataMember(Order=4)
    public studyEventOid: string;

    // @DataMember(Order=5)
    public caseReportFormOid: string;

    // @DataMember(Order=6)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=7)
    public itemGroupName: string;

    // @DataMember(Order=8)
    public itemName: string;

    // @DataMember(Order=9)
    public enabled?: boolean;

    // @DataMember(Order=10)
    public linked?: boolean;

    // @DataMember(Order=11)
    public priority?: SourceDataPriority;

    // @DataMember(Order=12)
    public name: string;

    // @DataMember(Order=13)
    public alertInformation: string;

    // @DataMember(Order=14)
    public alertWarning: string;

    // @DataMember(Order=15)
    public alertError: string;

    // @DataMember(Order=16)
    public alertSuccess: string;

    // @DataMember(Order=17)
    public allowReview?: boolean;

    // @DataMember(Order=18)
    public allowVerification?: boolean;

    // @DataMember(Order=19)
    public allowFindings?: boolean;

    // @DataMember(Order=20)
    public allowNotes?: boolean;

    // @DataMember(Order=21)
    public enteredDate?: string;

    // @DataMember(Order=22)
    public enteredBy: string;

    // @DataMember(Order=23)
    public modifiedDate?: string;

    // @DataMember(Order=24)
    public modifiedBy: string;

    public constructor(init?: Partial<ConfigurationSourceDataItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationSourceDataItemValue implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public configurationSourceDataId?: number;

    // @DataMember(Order=4)
    public studyEventOid: string;

    // @DataMember(Order=5)
    public caseReportFormOid: string;

    // @DataMember(Order=6)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=7)
    public itemGroupName: string;

    // @DataMember(Order=8)
    public itemName: string;

    // @DataMember(Order=9)
    public value: string;

    // @DataMember(Order=10)
    public linked?: boolean;

    // @DataMember(Order=11)
    public priority?: SourceDataPriority;

    // @DataMember(Order=12)
    public name: string;

    // @DataMember(Order=13)
    public alertInformation: string;

    // @DataMember(Order=14)
    public alertWarning: string;

    // @DataMember(Order=15)
    public alertError: string;

    // @DataMember(Order=16)
    public alertSuccess: string;

    // @DataMember(Order=17)
    public enteredDate?: string;

    // @DataMember(Order=18)
    public enteredBy: string;

    // @DataMember(Order=19)
    public modifiedDate?: string;

    // @DataMember(Order=20)
    public modifiedBy: string;

    public constructor(init?: Partial<ConfigurationSourceDataItemValue>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationSourceData implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public isGlobal?: boolean;

    // @DataMember(Order=4)
    public name: string;

    // @DataMember(Order=5)
    public description: string;

    // @DataMember(Order=6)
    public alertInformation: string;

    // @DataMember(Order=7)
    public alertWarning: string;

    // @DataMember(Order=8)
    public alertError: string;

    // @DataMember(Order=9)
    public alertSuccess: string;

    // @DataMember(Order=10)
    public enteredDate?: string;

    // @DataMember(Order=11)
    public enteredBy: string;

    // @DataMember(Order=12)
    public modifiedDate?: string;

    // @DataMember(Order=13)
    public modifiedBy: string;

    public constructor(init?: Partial<ConfigurationSourceData>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationSourceDataMap
{
    [immerable] = true;
    // @DataMember(Order=1)
    public configuration: ConfigurationSourceData;

    // @DataMember(Order=2)
    public events: { [index:string]: ConfigurationSourceDataEvent; };

    // @DataMember(Order=3)
    public forms: { [index:string]: { [index:string]: ConfigurationSourceDataForm; }; };

    // @DataMember(Order=4)
    public formVersions: { [index:string]: { [index:string]: { [index:string]: ConfigurationSourceDataFormVersion; }; }; };

    // @DataMember(Order=5)
    public itemGroups: { [index:string]: { [index:string]: { [index:string]: { [index:string]: ConfigurationSourceDataItemGroup; }; }; }; };

    // @DataMember(Order=6)
    public items: { [index:string]: { [index:string]: { [index:string]: { [index:string]: { [index:string]: ConfigurationSourceDataItem; }; }; }; }; };

    // @DataMember(Order=7)
    public itemValues: { [index:string]: { [index:string]: { [index:string]: { [index:string]: { [index:string]: { [index:string]: ConfigurationSourceDataItemValue; }; }; }; }; }; };

    public constructor(init?: Partial<ConfigurationSourceDataMap>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConfigurationTrial implements IHasAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public name: string;

    // @DataMember(Order=4)
    public protocol: string;

    // @DataMember(Order=5)
    public status?: ConfigurationStatus;

    // @DataMember(Order=6)
    public alertInformation: string;

    // @DataMember(Order=7)
    public alertWarning: string;

    // @DataMember(Order=8)
    public alertError: string;

    // @DataMember(Order=9)
    public alertSuccess: string;

    // @DataMember(Order=10)
    public allocationType?: SourceDataAllocationType;

    // @DataMember(Order=11)
    public enteredDate?: string;

    // @DataMember(Order=12)
    public enteredBy: string;

    // @DataMember(Order=13)
    public modifiedDate?: string;

    // @DataMember(Order=14)
    public modifiedBy: string;

    public constructor(init?: Partial<ConfigurationTrial>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CoordinatingGroup
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public code: string;

    // @DataMember(Order=5)
    public name: string;

    // @DataMember(Order=6)
    public status?: ConfigurationStatus;

    // @DataMember(Order=7)
    public defaultName: string;

    // @DataMember(Order=8)
    public metadata: { [index:string]: Object; };

    public constructor(init?: Partial<CoordinatingGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Institution
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public code: string;

    // @DataMember(Order=6)
    public name: string;

    // @DataMember(Order=7)
    public oid: string;

    // @DataMember(Order=8)
    public status?: ConfigurationStatus;

    // @DataMember(Order=9)
    public defaultName: string;

    // @DataMember(Order=10)
    public metadata: { [index:string]: Object; };

    // @DataMember(Order=11)
    public openClinicaStudyId?: number;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroup
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public code: string;

    // @DataMember(Order=4)
    public name: string;

    // @DataMember(Order=5)
    public status?: ConfigurationStatus;

    // @DataMember(Order=6)
    public defaultName: string;

    // @DataMember(Order=7)
    public metadata: { [index:string]: Object; };

    public constructor(init?: Partial<MasterGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MetadataEventForm
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public studyEventOid: string;

    // @DataMember(Order=4)
    public caseReportFormOid: string;

    // @DataMember(Order=5)
    public order?: number;

    // @DataMember(Order=6)
    public required?: boolean;

    public constructor(init?: Partial<MetadataEventForm>) { (Object as any).assign(this, init); }
}

export enum SourceDataEventType
{
    Single = 1,
    Repeating = 2,
}

// @DataContract
export class MetadataEvent
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public studyEventOid: string;

    // @DataMember(Order=4)
    public name: string;

    // @DataMember(Order=5)
    public type?: SourceDataEventType;

    // @DataMember(Order=6)
    public order?: number;

    public constructor(init?: Partial<MetadataEvent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MetadataForm
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public caseReportFormOid: string;

    // @DataMember(Order=4)
    public name: string;

    public constructor(init?: Partial<MetadataForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MetadataFormVersion
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public caseReportFormOid: string;

    // @DataMember(Order=4)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=5)
    public name: string;

    // @DataMember(Order=6)
    public order?: number;

    public constructor(init?: Partial<MetadataFormVersion>) { (Object as any).assign(this, init); }
}

export enum SourceDataItemGroupType
{
    Group = 1,
    Grid = 2,
}

// @DataContract
export class MetadataItemGroup
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public caseReportFormOid: string;

    // @DataMember(Order=4)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=5)
    public itemGroupName: string;

    // @DataMember(Order=6)
    public name: string;

    // @DataMember(Order=7)
    public type?: SourceDataItemGroupType;

    // @DataMember(Order=8)
    public rowsMinimum?: number;

    // @DataMember(Order=9)
    public rowsMaximum?: number;

    public constructor(init?: Partial<MetadataItemGroup>) { (Object as any).assign(this, init); }
}

export enum SourceDataItemType
{
    String = 1,
    Integer = 2,
    Decimal = 3,
    Boolean = 4,
    Date = 5,
    Json = 6,
}

export enum SourceDataFieldType
{
    Text = 1,
    Radio = 2,
    Checkbox = 3,
    File = 4,
    Numeric = 5,
    Select = 6,
    MultiSelect = 7,
    MultilineText = 8,
    Date = 9,
    Ctcae = 10,
    Hidden = 11,
}

// @DataContract
export class MetadataItem
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public caseReportFormOid: string;

    // @DataMember(Order=4)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=5)
    public itemGroupName: string;

    // @DataMember(Order=6)
    public itemName: string;

    // @DataMember(Order=7)
    public name: string;

    // @DataMember(Order=8)
    public type?: SourceDataItemType;

    // @DataMember(Order=9)
    public fieldType?: SourceDataFieldType;

    // @DataMember(Order=10)
    public order?: number;

    // @DataMember(Order=11)
    public metadata: { [index:string]: string; };

    // @DataMember(Order=12)
    public header: string;

    public constructor(init?: Partial<MetadataItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MetadataItemValue
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public caseReportFormOid: string;

    // @DataMember(Order=4)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=5)
    public itemGroupName: string;

    // @DataMember(Order=6)
    public itemName: string;

    // @DataMember(Order=7)
    public name: string;

    // @DataMember(Order=8)
    public value: string;

    // @DataMember(Order=9)
    public order?: number;

    public constructor(init?: Partial<MetadataItemValue>) { (Object as any).assign(this, init); }
}

export enum UpdateStatusEventType
{
    Started = 1,
    ProgressUpdate = 2,
    Complete = 3,
    Queued = 4,
}

export enum UpdateStatusDataType
{
    All = 1,
    Reviews = 2,
    Verifications = 3,
    ReviewsAndVerifications = 4,
}

export class UpdateStatusEvent
{
    [immerable] = true;
    public type?: UpdateStatusEventType;
    public dataType?: UpdateStatusDataType;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public message: string;

    public constructor(init?: Partial<UpdateStatusEvent>) { (Object as any).assign(this, init); }
}

export enum UpdateCachedDataEventType
{
    Started = 1,
    Complete = 2,
}

export class UpdateCachedDataEvent
{
    [immerable] = true;
    public type?: UpdateCachedDataEventType;

    public constructor(init?: Partial<UpdateCachedDataEvent>) { (Object as any).assign(this, init); }
}

export class UpdatedSourceDataReviewEvent
{
    [immerable] = true;
    public sourceDataReviewId?: number;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;
    public value: string;
    public reviewed?: boolean;

    public constructor(init?: Partial<UpdatedSourceDataReviewEvent>) { (Object as any).assign(this, init); }
}

export class UpdatedSourceDataVerificationEvent
{
    [immerable] = true;
    public sourceDataVerificationId?: number;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;
    public value: string;
    public verified?: boolean;

    public constructor(init?: Partial<UpdatedSourceDataVerificationEvent>) { (Object as any).assign(this, init); }
}

export class UpdatedNoteEvent
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;

    public constructor(init?: Partial<UpdatedNoteEvent>) { (Object as any).assign(this, init); }
}

export class UpdatedSourceDataFindingEvent
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;

    public constructor(init?: Partial<UpdatedSourceDataFindingEvent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataPoint
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public sourceDataFormContextId?: number;

    // @DataMember(Order=3)
    public itemGroupName: string;

    // @DataMember(Order=4)
    public itemGroupRepeat?: number;

    // @DataMember(Order=5)
    public itemName: string;

    // @DataMember(Order=6)
    public value: string;

    // @DataMember(Order=7)
    public priority?: SourceDataPriority;

    public constructor(init?: Partial<SourceDataPoint>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataReview
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public sourceDataPointId?: number;

    // @DataMember(Order=3)
    public reviewed?: boolean;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public enteredBy: string;

    // @DataMember(Order=6)
    public enteredByFirstName: string;

    // @DataMember(Order=7)
    public enteredByLastName: string;

    public constructor(init?: Partial<SourceDataReview>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataVerification
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public sourceDataPointId?: number;

    // @DataMember(Order=3)
    public verified?: boolean;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public enteredBy: string;

    // @DataMember(Order=6)
    public enteredByFirstName: string;

    // @DataMember(Order=7)
    public enteredByLastName: string;

    public constructor(init?: Partial<SourceDataVerification>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataItemState
{
    [immerable] = true;
    // @DataMember(Order=1)
    public point: SourceDataPoint;

    // @DataMember(Order=2)
    public review: SourceDataReview;

    // @DataMember(Order=3)
    public verification: SourceDataVerification;

    public constructor(init?: Partial<SourceDataItemState>) { (Object as any).assign(this, init); }
}

export class UpdatedCaseReportFormStateEvent
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public updates: SourceDataItemState[] = [];

    public constructor(init?: Partial<UpdatedCaseReportFormStateEvent>) { (Object as any).assign(this, init); }
}

export enum NoteType
{
    System = 1,
    Annotation = 2,
    SiteQuery = 3,
    ReasonForChange = 4,
    InternalQuery = 5,
    ProtocolDeviation = 6,
    ImportantProtocolDeviation = 7,
}

export enum NoteStatus
{
    New = 1,
    Updated = 2,
    ResolutionProposed = 3,
    Closed = 4,
    NotApplicable = 5,
}

// @DataContract
export class Participant
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public studyNumber: string;

    // @DataMember(Order=7)
    public oid: string;

    // @DataMember(Order=8)
    public treatmentArm: string;

    // @DataMember(Order=9)
    public enrolmentDate?: string;

    // @DataMember(Order=10)
    public status?: ConfigurationStatus;

    // @DataMember(Order=11)
    public metadata: { [index:string]: Object; };

    // @DataMember(Order=12)
    public openClinicaStudySubjectId?: number;

    public constructor(init?: Partial<Participant>) { (Object as any).assign(this, init); }
}

export enum SourceDataFindingStatus
{
    Pending = 1,
    Resolved = 2,
    NotApplicable = 3,
}

export enum SourceDataFindingType
{
    Information = 1,
    ProtocolDeviation = 2,
    ImportantProtocolDeviation = 3,
}

// @DataContract
export class SourceDataFinding
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public studyEventOid: string;

    // @DataMember(Order=8)
    public studyEventRepeat?: number;

    // @DataMember(Order=9)
    public caseReportFormOid: string;

    // @DataMember(Order=10)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=11)
    public itemGroupName: string;

    // @DataMember(Order=12)
    public itemGroupRepeat?: number;

    // @DataMember(Order=13)
    public itemName: string;

    // @DataMember(Order=14)
    public status?: SourceDataFindingStatus;

    // @DataMember(Order=15)
    public type?: SourceDataFindingType;

    // @DataMember(Order=16)
    public reference: string;

    // @DataMember(Order=17)
    public detail: string;

    // @DataMember(Order=18)
    public creator: string;

    // @DataMember(Order=19)
    public creatorUsername: string;

    // @DataMember(Order=20)
    public createdDate?: string;

    // @DataMember(Order=21)
    public resolver: string;

    // @DataMember(Order=22)
    public resolverUsername: string;

    // @DataMember(Order=23)
    public resolvedDate?: string;

    // @DataMember(Order=24)
    public resolution: string;

    // @DataMember(Order=25)
    public discussedWith: string;

    // @DataMember(Order=26)
    public enteredDate?: string;

    // @DataMember(Order=27)
    public enteredBy: string;

    // @DataMember(Order=28)
    public modifiedDate?: string;

    // @DataMember(Order=29)
    public modifiedBy: string;

    public constructor(init?: Partial<SourceDataFinding>) { (Object as any).assign(this, init); }
}

export enum SourceDataReportType
{
    Reviewed = 1,
    Verified = 2,
}

export class SourceDataReviewAndVerificationUpdate
{
    [immerable] = true;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;
    public value: string;
    public priority?: SourceDataPriority;
    public reviewed?: boolean;
    public verified?: boolean;

    public constructor(init?: Partial<SourceDataReviewAndVerificationUpdate>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataStatus implements IHasSourceDataStatus
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public studyEventOid: string;

    // @DataMember(Order=8)
    public studyEventRepeat?: number;

    // @DataMember(Order=9)
    public caseReportFormOid: string;

    // @DataMember(Order=10)
    public updating?: boolean;

    // @DataMember(Order=11)
    public updatedDate?: string;

    // @DataMember(Order=12)
    public formsTotalCount?: number;

    // @DataMember(Order=13)
    public formsCompleteCount?: number;

    // @DataMember(Order=14)
    public siteQueryTotalCount?: number;

    // @DataMember(Order=15)
    public siteQueryNewCount?: number;

    // @DataMember(Order=16)
    public siteQueryUpdatedCount?: number;

    // @DataMember(Order=17)
    public siteQueryResolutionProposedCount?: number;

    // @DataMember(Order=18)
    public siteQueryClosedCount?: number;

    // @DataMember(Order=19)
    public internalQueryTotalCount?: number;

    // @DataMember(Order=20)
    public internalQueryNewCount?: number;

    // @DataMember(Order=21)
    public internalQueryUpdatedCount?: number;

    // @DataMember(Order=22)
    public internalQueryResolutionProposedCount?: number;

    // @DataMember(Order=23)
    public internalQueryClosedCount?: number;

    // @DataMember(Order=24)
    public systemQueryTotalCount?: number;

    // @DataMember(Order=25)
    public systemQueryNewCount?: number;

    // @DataMember(Order=26)
    public systemQueryUpdatedCount?: number;

    // @DataMember(Order=27)
    public systemQueryResolutionProposedCount?: number;

    // @DataMember(Order=28)
    public systemQueryClosedCount?: number;

    // @DataMember(Order=29)
    public reasonForChangeCount?: number;

    // @DataMember(Order=30)
    public annotationCount?: number;

    // @DataMember(Order=31)
    public protocolDeviationCount?: number;

    // @DataMember(Order=32)
    public importantProtocolDeviationCount?: number;

    // @DataMember(Order=33)
    public reviewTotalCount?: number;

    // @DataMember(Order=34)
    public reviewCompleteCount?: number;

    // @DataMember(Order=35)
    public reviewLowPriorityCompleteCount?: number;

    // @DataMember(Order=36)
    public reviewLowPriorityTotalCount?: number;

    // @DataMember(Order=37)
    public reviewNormalPriorityCompleteCount?: number;

    // @DataMember(Order=38)
    public reviewNormalPriorityTotalCount?: number;

    // @DataMember(Order=39)
    public reviewHighPriorityCompleteCount?: number;

    // @DataMember(Order=40)
    public reviewHighPriorityTotalCount?: number;

    // @DataMember(Order=41)
    public reviewCriticalPriorityCompleteCount?: number;

    // @DataMember(Order=42)
    public reviewCriticalPriorityTotalCount?: number;

    // @DataMember(Order=43)
    public verificationTotalCount?: number;

    // @DataMember(Order=44)
    public verificationCompleteCount?: number;

    // @DataMember(Order=45)
    public verificationLowPriorityCompleteCount?: number;

    // @DataMember(Order=46)
    public verificationLowPriorityTotalCount?: number;

    // @DataMember(Order=47)
    public verificationNormalPriorityCompleteCount?: number;

    // @DataMember(Order=48)
    public verificationNormalPriorityTotalCount?: number;

    // @DataMember(Order=49)
    public verificationHighPriorityCompleteCount?: number;

    // @DataMember(Order=50)
    public verificationHighPriorityTotalCount?: number;

    // @DataMember(Order=51)
    public verificationCriticalPriorityCompleteCount?: number;

    // @DataMember(Order=52)
    public verificationCriticalPriorityTotalCount?: number;

    // @DataMember(Order=53)
    public participantCount?: number;

    public constructor(init?: Partial<SourceDataStatus>) { (Object as any).assign(this, init); }
}

export interface IHasSourceDataStatus
{
    updating?: boolean;
    updatedDate?: string;
    formsTotalCount?: number;
    formsCompleteCount?: number;
    siteQueryTotalCount?: number;
    siteQueryNewCount?: number;
    siteQueryUpdatedCount?: number;
    siteQueryResolutionProposedCount?: number;
    siteQueryClosedCount?: number;
    internalQueryTotalCount?: number;
    internalQueryNewCount?: number;
    internalQueryUpdatedCount?: number;
    internalQueryResolutionProposedCount?: number;
    internalQueryClosedCount?: number;
    systemQueryTotalCount?: number;
    systemQueryNewCount?: number;
    systemQueryUpdatedCount?: number;
    systemQueryResolutionProposedCount?: number;
    systemQueryClosedCount?: number;
    reasonForChangeCount?: number;
    annotationCount?: number;
    protocolDeviationCount?: number;
    importantProtocolDeviationCount?: number;
    reviewTotalCount?: number;
    reviewCompleteCount?: number;
    verificationTotalCount?: number;
    verificationCompleteCount?: number;
}

// @DataContract
export class QueryBase
{
    [immerable] = true;
    // @DataMember(Order=1)
    public skip?: number;

    // @DataMember(Order=2)
    public take?: number;

    // @DataMember(Order=3)
    public orderBy: string;

    // @DataMember(Order=4)
    public orderByDesc: string;

    // @DataMember(Order=5)
    public include: string;

    // @DataMember(Order=6)
    public fields: string;

    // @DataMember(Order=7)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<QueryBase>) { (Object as any).assign(this, init); }
}

export class QueryData<T> extends QueryBase
{
    [immerable] = true;

    public constructor(init?: Partial<QueryData<T>>) { super(init); (Object as any).assign(this, init); }
}

// @DataContract
export class Trial
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public protocol: string;

    // @DataMember(Order=3)
    public name: string;

    // @DataMember(Order=5)
    public oid: string;

    // @DataMember(Order=6)
    public status?: ConfigurationStatus;

    // @DataMember(Order=7)
    public defaultName: string;

    // @DataMember(Order=8)
    public defaultProtocol: string;

    // @DataMember(Order=9)
    public metadata: { [index:string]: Object; };

    // @DataMember(Order=10)
    public openClinicaStudyId?: number;

    public constructor(init?: Partial<Trial>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    [immerable] = true;
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable] = true;
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export enum Customer
{
    Bct = 1,
    Trog = 2,
    Unknown = 2147483647,
}

export class Palette
{
    [immerable] = true;
    public primaryLight: string;
    public primaryDark: string;
    public secondaryLight: string;
    public secondaryDark: string;

    public constructor(init?: Partial<Palette>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    [immerable] = true;
    public dsn: string;
    public environment: string;
    public customer: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public profileSessionSampleRate?: number;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    [immerable] = true;
    public homeUrl: string;
    public ctcaeUrl: string;
    public customer?: Customer;
    public palette: Palette;
    public sentry: SentrySettings;
    public noteTypes: NoteType[];

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Metadata
{
    [immerable] = true;
    // @DataMember(Order=1)
    public events: { [index:string]: MetadataEvent; };

    // @DataMember(Order=2)
    public eventForms: { [index:string]: { [index:string]: MetadataEventForm; }; };

    // @DataMember(Order=3)
    public forms: { [index:string]: MetadataForm; };

    // @DataMember(Order=4)
    public formVersions: { [index:string]: { [index:string]: MetadataFormVersion; }; };

    // @DataMember(Order=5)
    public itemGroups: { [index:string]: { [index:string]: { [index:string]: MetadataItemGroup; }; }; };

    // @DataMember(Order=6)
    public items: { [index:string]: { [index:string]: { [index:string]: { [index:string]: MetadataItem; }; }; }; };

    // @DataMember(Order=7)
    public itemValues: { [index:string]: { [index:string]: { [index:string]: { [index:string]: { [index:string]: MetadataItemValue; }; }; }; }; };

    public constructor(init?: Partial<Metadata>) { (Object as any).assign(this, init); }
}

// @DataContract
export class NoteDetail
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @References("typeof(SourceDataVerification.ServiceLogic.Models.Note)")
    public noteId?: number;

    // @DataMember(Order=3)
    public title: string;

    // @DataMember(Order=4)
    public details: string;

    // @DataMember(Order=5)
    public creatorFirstName: string;

    // @DataMember(Order=6)
    public creatorLastName: string;

    // @DataMember(Order=7)
    public creatorUsername: string;

    // @DataMember(Order=8)
    public status?: NoteStatus;

    // @DataMember(Order=9)
    public createdDate?: string;

    public constructor(init?: Partial<NoteDetail>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Note
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public studyEventOid: string;

    // @DataMember(Order=8)
    public studyEventRepeat?: number;

    // @DataMember(Order=9)
    public caseReportFormOid: string;

    // @DataMember(Order=10)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=11)
    public itemGroupName: string;

    // @DataMember(Order=12)
    public itemGroupRepeat?: number;

    // @DataMember(Order=13)
    public itemName: string;

    // @DataMember(Order=22)
    public itemValue: string;

    // @DataMember(Order=14)
    public columnName: string;

    // @DataMember(Order=15)
    public creatorFirstName: string;

    // @DataMember(Order=16)
    public creatorLastName: string;

    // @DataMember(Order=17)
    public creatorUsername: string;

    // @DataMember(Order=18)
    public type?: NoteType;

    // @DataMember(Order=19)
    public status?: NoteStatus;

    // @DataMember(Order=20)
    public createdDate?: string;

    // @DataMember(Order=21)
    public details: NoteDetail[];

    public constructor(init?: Partial<Note>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataEvent
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public studyEventOid: string;

    // @DataMember(Order=8)
    public studyEventRepeat?: number;

    // @DataMember(Order=9)
    public status?: SourceDataEventStatus;

    // @DataMember(Order=10)
    public startDate?: string;

    public constructor(init?: Partial<SourceDataEvent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataForm
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public studyEventOid: string;

    // @DataMember(Order=8)
    public studyEventRepeat?: number;

    // @DataMember(Order=9)
    public caseReportFormOid: string;

    // @DataMember(Order=10)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=11)
    public status?: SourceDataFormStatus;

    // @DataMember(Order=12)
    public startDate?: string;

    // @DataMember(Order=13)
    public updateDate?: string;

    // @DataMember(Order=14)
    public completeDate?: string;

    public constructor(init?: Partial<SourceDataForm>) { (Object as any).assign(this, init); }
}

export enum AuditType
{
    Inserted = 1,
    Updated = 2,
    Deleted = 3,
}

// @DataContract
export class SourceDataItemAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public studyEventOid: string;

    // @DataMember(Order=8)
    public studyEventRepeat?: number;

    // @DataMember(Order=9)
    public caseReportFormOid: string;

    // @DataMember(Order=10)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=11)
    public itemGroupName: string;

    // @DataMember(Order=12)
    public itemGroupRepeat?: number;

    // @DataMember(Order=13)
    public itemName: string;

    // @DataMember(Order=14)
    public oldValue: string;

    // @DataMember(Order=15)
    public newValue: string;

    // @DataMember(Order=16)
    public auditDate?: string;

    // @DataMember(Order=17)
    public auditType?: AuditType;

    // @DataMember(Order=18)
    public updateDate?: string;

    // @DataMember(Order=19)
    public editorFirstName: string;

    // @DataMember(Order=20)
    public editorLastName: string;

    // @DataMember(Order=21)
    public editorUsername: string;

    public constructor(init?: Partial<SourceDataItemAudit>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataReviewAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public sourceDataPointId?: number;

    // @DataMember(Order=3)
    public value: string;

    // @DataMember(Order=4)
    public reviewed?: boolean;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public enteredBy: string;

    // @DataMember(Order=7)
    public enteredByFirstName: string;

    // @DataMember(Order=8)
    public enteredByLastName: string;

    public constructor(init?: Partial<SourceDataReviewAudit>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataVerificationAudit
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public sourceDataPointId?: number;

    // @DataMember(Order=3)
    public value: string;

    // @DataMember(Order=4)
    public verified?: boolean;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public enteredBy: string;

    // @DataMember(Order=7)
    public enteredByFirstName: string;

    // @DataMember(Order=8)
    public enteredByLastName: string;

    public constructor(init?: Partial<SourceDataVerificationAudit>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataItem
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public studyEventOid: string;

    // @DataMember(Order=8)
    public studyEventRepeat?: number;

    // @DataMember(Order=9)
    public caseReportFormOid: string;

    // @DataMember(Order=10)
    public caseReportFormVersionOid: string;

    // @DataMember(Order=11)
    public itemGroupName: string;

    // @DataMember(Order=12)
    public itemGroupRepeat?: number;

    // @DataMember(Order=13)
    public itemName: string;

    // @DataMember(Order=14)
    public value: string;

    public constructor(init?: Partial<SourceDataItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataEventContext
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public participantId?: number;

    // @DataMember(Order=7)
    public studyEventOid: string;

    // @DataMember(Order=8)
    public studyEventRepeat?: number;

    public constructor(init?: Partial<SourceDataEventContext>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataFormContext
{
    [immerable] = true;
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public sourceDataEventContextId?: number;

    // @DataMember(Order=3)
    public caseReportFormOid: string;

    // @DataMember(Order=4)
    public caseReportFormVersionOid: string;

    public constructor(init?: Partial<SourceDataFormContext>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataReportItem
{
    [immerable] = true;
    // @DataMember(Order=1)
    public type: SourceDataReportType;

    // @DataMember(Order=2)
    public sourceDataPointId?: number;

    // @DataMember(Order=3)
    public value: string;

    // @DataMember(Order=4)
    public state?: boolean;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public enteredBy: string;

    // @DataMember(Order=7)
    public enteredByFirstName: string;

    // @DataMember(Order=8)
    public enteredByLastName: string;

    public constructor(init?: Partial<SourceDataReportItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataReport
{
    [immerable] = true;
    // @DataMember(Order=1)
    public events: SourceDataEventContext[] = [];

    // @DataMember(Order=2)
    public forms: SourceDataFormContext[] = [];

    // @DataMember(Order=3)
    public points: SourceDataPoint[] = [];

    // @DataMember(Order=4)
    public items: SourceDataReportItem[];

    public constructor(init?: Partial<SourceDataReport>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataReportUser
{
    [immerable] = true;
    // @DataMember(Order=1)
    public username: string;

    // @DataMember(Order=2)
    public firstName: string;

    // @DataMember(Order=3)
    public lastName: string;

    public constructor(init?: Partial<SourceDataReportUser>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceData
{
    [immerable] = true;
    // @DataMember(Order=1)
    public events: { [index:string]: { [index:number]: SourceDataEvent; }; };

    // @DataMember(Order=2)
    public forms: { [index:string]: { [index:number]: { [index:string]: SourceDataForm; }; }; };

    // @DataMember(Order=3)
    public items: { [index:string]: { [index:number]: { [index:string]: { [index:string]: { [index:number]: { [index:string]: SourceDataItem; }; }; }; }; }; };

    // @DataMember(Order=4)
    public date?: string;

    public constructor(init?: Partial<SourceData>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueryResponse<T>
{
    [immerable] = true;
    // @DataMember(Order=1)
    public offset: number;

    // @DataMember(Order=2)
    public total: number;

    // @DataMember(Order=3)
    public results: T[] = [];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    // @DataMember(Order=5)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryResponse<T>>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    [immerable] = true;
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataFormState
{
    [immerable] = true;
    // @DataMember(Order=1)
    public form: SourceDataFormContext;

    // @DataMember(Order=2)
    public items: { [index:string]: { [index:number]: { [index:string]: SourceDataItemState; }; }; };

    public constructor(init?: Partial<SourceDataFormState>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDataEventState
{
    [immerable] = true;
    // @DataMember(Order=1)
    public event: SourceDataEventContext;

    // @DataMember(Order=2)
    public forms: { [index:string]: SourceDataFormState; };

    public constructor(init?: Partial<SourceDataEventState>) { (Object as any).assign(this, init); }
}

export class UpdateCacheResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateCacheResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    [immerable] = true;
    public settings: ClientAppSettings;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class SaveConfigurationCoordinatingGroupResponse
{
    [immerable] = true;
    public data: ConfigurationCoordinatingGroup;
    public allocations: ConfigurationSourceDataAllocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaveConfigurationCoordinatingGroupResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationCoordinatingGroupsResponse
{
    [immerable] = true;
    public data: ConfigurationCoordinatingGroup[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationCoordinatingGroupsResponse>) { (Object as any).assign(this, init); }
}

export class SaveConfigurationInstitutionResponse
{
    [immerable] = true;
    public data: ConfigurationInstitution;
    public allocations: ConfigurationSourceDataAllocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaveConfigurationInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationInstitutionsResponse
{
    [immerable] = true;
    public data: ConfigurationInstitution[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class SaveConfigurationMasterGroupResponse
{
    [immerable] = true;
    public data: ConfigurationMasterGroup;
    public allocations: ConfigurationSourceDataAllocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaveConfigurationMasterGroupResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationMasterGroupsResponse
{
    [immerable] = true;
    public data: ConfigurationMasterGroup[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationMasterGroupsResponse>) { (Object as any).assign(this, init); }
}

export class SaveConfigurationParticipantResponse
{
    [immerable] = true;
    public data: ConfigurationParticipant;
    public allocations: ConfigurationSourceDataAllocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaveConfigurationParticipantResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationParticipantsResponse
{
    [immerable] = true;
    public data: ConfigurationParticipant[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationParticipantsResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationSourceDataAllocationsResponse
{
    [immerable] = true;
    public data: ConfigurationSourceDataAllocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationSourceDataAllocationsResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationSourceDataEventsResponse
{
    [immerable] = true;
    public data: ConfigurationSourceDataEvent[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationSourceDataEventsResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationSourceDataFormsResponse
{
    [immerable] = true;
    public data: ConfigurationSourceDataForm[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationSourceDataFormsResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationSourceDataFormVersionsResponse
{
    [immerable] = true;
    public data: ConfigurationSourceDataFormVersion[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationSourceDataFormVersionsResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationSourceDataItemGroupsResponse
{
    [immerable] = true;
    public data: ConfigurationSourceDataItemGroup[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationSourceDataItemGroupsResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationSourceDataItemsResponse
{
    [immerable] = true;
    public data: ConfigurationSourceDataItem[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationSourceDataItemsResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationSourceDataItemValuesResponse
{
    [immerable] = true;
    public data: ConfigurationSourceDataItemValue[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationSourceDataItemValuesResponse>) { (Object as any).assign(this, init); }
}

export class GetConfigurationSourceDataResponse
{
    [immerable] = true;
    public data: ConfigurationSourceDataMap;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetConfigurationSourceDataResponse>) { (Object as any).assign(this, init); }
}

export class SaveConfigurationSourceDataResponse
{
    [immerable] = true;
    public data: ConfigurationSourceData;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaveConfigurationSourceDataResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationSourceDatasResponse
{
    [immerable] = true;
    public data: ConfigurationSourceData[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationSourceDatasResponse>) { (Object as any).assign(this, init); }
}

export class SaveConfigurationTrialResponse
{
    [immerable] = true;
    public data: ConfigurationTrial;
    public allocations: ConfigurationSourceDataAllocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaveConfigurationTrialResponse>) { (Object as any).assign(this, init); }
}

export class QueryConfigurationTrialsResponse
{
    [immerable] = true;
    public data: ConfigurationTrial[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryConfigurationTrialsResponse>) { (Object as any).assign(this, init); }
}

export class QueryCoordinatingGroupsResponse
{
    [immerable] = true;
    public data: CoordinatingGroup[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryCoordinatingGroupsResponse>) { (Object as any).assign(this, init); }
}

export class GetMetadataResponse
{
    [immerable] = true;
    public data: Metadata;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetMetadataResponse>) { (Object as any).assign(this, init); }
}

export class QueryInstitutionsResponse
{
    [immerable] = true;
    public data: Institution[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class QueryMasterGroupsResponse
{
    [immerable] = true;
    public data: MasterGroup[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryMasterGroupsResponse>) { (Object as any).assign(this, init); }
}

export class QueryMetadataEventFormsResponse
{
    [immerable] = true;
    public data: MetadataEventForm[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryMetadataEventFormsResponse>) { (Object as any).assign(this, init); }
}

export class QueryMetadataEventsResponse
{
    [immerable] = true;
    public data: MetadataEvent[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryMetadataEventsResponse>) { (Object as any).assign(this, init); }
}

export class QueryMetadataFormsResponse
{
    [immerable] = true;
    public data: MetadataForm[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryMetadataFormsResponse>) { (Object as any).assign(this, init); }
}

export class QueryMetadataFormVersionsResponse
{
    [immerable] = true;
    public data: MetadataFormVersion[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryMetadataFormVersionsResponse>) { (Object as any).assign(this, init); }
}

export class QueryMetadataItemGroupsResponse
{
    [immerable] = true;
    public data: MetadataItemGroup[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryMetadataItemGroupsResponse>) { (Object as any).assign(this, init); }
}

export class QueryMetadataItemsResponse
{
    [immerable] = true;
    public data: MetadataItem[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryMetadataItemsResponse>) { (Object as any).assign(this, init); }
}

export class QueryMetadataItemValuesResponse
{
    [immerable] = true;
    public data: MetadataItemValue[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryMetadataItemValuesResponse>) { (Object as any).assign(this, init); }
}

export class HelloResponse
{
    [immerable] = true;
    public result: string;

    public constructor(init?: Partial<HelloResponse>) { (Object as any).assign(this, init); }
}

export class GenTypes implements IReturn<GenTypes>
{
    [immerable] = true;
    public updateStatusEvent: UpdateStatusEvent;
    public updateCachedDataEvent: UpdateCachedDataEvent;
    public updatedSourceDataReviewEvent: UpdatedSourceDataReviewEvent;
    public updatedSourceDataVerificationEvent: UpdatedSourceDataVerificationEvent;
    public updatedNoteEvent: UpdatedNoteEvent;
    public updatedSourceDataFindingEvent: UpdatedSourceDataFindingEvent;
    public updatedCaseReportFormStateEvent: UpdatedCaseReportFormStateEvent;

    public constructor(init?: Partial<GenTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GenTypes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenTypes(); }
}

export class TestCorsResponse
{
    [immerable] = true;
    public result: string;

    public constructor(init?: Partial<TestCorsResponse>) { (Object as any).assign(this, init); }
}

export class GetNotesResponse
{
    [immerable] = true;
    public data: Note[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetNotesResponse>) { (Object as any).assign(this, init); }
}

export class NoteUpdateResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<NoteUpdateResponse>) { (Object as any).assign(this, init); }
}

export class QueryParticipantsResponse
{
    [immerable] = true;
    public data: Participant[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryParticipantsResponse>) { (Object as any).assign(this, init); }
}

export class CalculateParticipantSourceDataAllocationsResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;
    public updates: ParticipantSourceDataAllocationUpdate[];

    public constructor(init?: Partial<CalculateParticipantSourceDataAllocationsResponse>) { (Object as any).assign(this, init); }
}

export class QueryParticipantSourceDataAllocationsResponse
{
    [immerable] = true;
    public data: ParticipantSourceDataAllocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryParticipantSourceDataAllocationsResponse>) { (Object as any).assign(this, init); }
}

export class ChannelsResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ChannelsResponse>) { (Object as any).assign(this, init); }
}

export class QuerySourceDataEventsResponse
{
    [immerable] = true;
    public data: SourceDataEvent[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QuerySourceDataEventsResponse>) { (Object as any).assign(this, init); }
}

export class GetSourceDataFindingsResponse
{
    [immerable] = true;
    public data: SourceDataFinding[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetSourceDataFindingsResponse>) { (Object as any).assign(this, init); }
}

export class PostSourceDataFindingSaveResponse
{
    [immerable] = true;
    public data: SourceDataFinding;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostSourceDataFindingSaveResponse>) { (Object as any).assign(this, init); }
}

export class PostSourceDataFindingDeleteResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostSourceDataFindingDeleteResponse>) { (Object as any).assign(this, init); }
}

export class QuerySourceDataFindingsResponse
{
    [immerable] = true;
    public data: SourceDataFinding[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QuerySourceDataFindingsResponse>) { (Object as any).assign(this, init); }
}

export class QuerySourceDataFormsResponse
{
    [immerable] = true;
    public data: SourceDataForm[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QuerySourceDataFormsResponse>) { (Object as any).assign(this, init); }
}

export class GetSourceDataItemAuditResponse
{
    [immerable] = true;
    public audit: SourceDataItemAudit[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetSourceDataItemAuditResponse>) { (Object as any).assign(this, init); }
}

export class GetSourceDataReviewAuditResponse
{
    [immerable] = true;
    public audit: SourceDataReviewAudit[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetSourceDataReviewAuditResponse>) { (Object as any).assign(this, init); }
}

export class GetSourceDataVerificationAuditResponse
{
    [immerable] = true;
    public audit: SourceDataVerificationAudit[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetSourceDataVerificationAuditResponse>) { (Object as any).assign(this, init); }
}

export class QuerySourceDataItemsResponse
{
    [immerable] = true;
    public data: SourceDataItem[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QuerySourceDataItemsResponse>) { (Object as any).assign(this, init); }
}

export class GetSourceDataReportResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;
    public report: SourceDataReport;

    public constructor(init?: Partial<GetSourceDataReportResponse>) { (Object as any).assign(this, init); }
}

export class GetSourceDataReportUsersResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;
    public users: SourceDataReportUser[];

    public constructor(init?: Partial<GetSourceDataReportUsersResponse>) { (Object as any).assign(this, init); }
}

export class QuerySourceDatasResponse
{
    [immerable] = true;
    public data: SourceData;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QuerySourceDatasResponse>) { (Object as any).assign(this, init); }
}

export class GetCaseReportFormStateResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;
    public events: { [index:string]: { [index:number]: SourceDataEventState; }; };

    public constructor(init?: Partial<GetCaseReportFormStateResponse>) { (Object as any).assign(this, init); }
}

export class UpdateSourceDataItemStateResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateSourceDataItemStateResponse>) { (Object as any).assign(this, init); }
}

export class UpdateCaseReportFormStateResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateCaseReportFormStateResponse>) { (Object as any).assign(this, init); }
}

export class UpdateSourceDataReviewAndVerificationCountsResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateSourceDataReviewAndVerificationCountsResponse>) { (Object as any).assign(this, init); }
}

export class QuerySourceDataStatusesResponse
{
    [immerable] = true;
    public data: SourceDataStatus[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QuerySourceDataStatusesResponse>) { (Object as any).assign(this, init); }
}

export class UpdateStatusResponse
{
    [immerable] = true;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateStatusResponse>) { (Object as any).assign(this, init); }
}

export class Todo
{
    [immerable] = true;
    public id: number;
    public text: string;
    public isFinished: boolean;

    public constructor(init?: Partial<Todo>) { (Object as any).assign(this, init); }
}

export class QueryTrialsResponse
{
    [immerable] = true;
    public data: Trial[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryTrialsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public authProvider: string;

    // @DataMember(Order=13)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=14)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

export class QueueUpdateCache implements IReturn<UpdateCacheResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<QueueUpdateCache>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueUpdateCache'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateCacheResponse(); }
}

export class UpdateCache implements IReturn<UpdateCacheResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<UpdateCache>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateCache'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateCacheResponse(); }
}

export class ScheduledUpdate implements IReturn<UpdateCacheResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<ScheduledUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScheduledUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateCacheResponse(); }
}

export class CreateMetadataCacheFiles implements IReturn<UpdateCacheResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<CreateMetadataCacheFiles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateMetadataCacheFiles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateCacheResponse(); }
}

export class CreateConfigurationCacheFiles implements IReturn<UpdateCacheResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<CreateConfigurationCacheFiles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateConfigurationCacheFiles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateCacheResponse(); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

export class SaveConfigurationCoordinatingGroup implements IReturn<SaveConfigurationCoordinatingGroupResponse>
{
    [immerable] = true;
    public data: ConfigurationCoordinatingGroup;
    public allocations: ConfigurationSourceDataAllocation[];
    public participantSourceDataAllocationUpdates: ParticipantSourceDataAllocationUpdate[];

    public constructor(init?: Partial<SaveConfigurationCoordinatingGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveConfigurationCoordinatingGroup'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveConfigurationCoordinatingGroupResponse(); }
}

export class QueryConfigurationCoordinatingGroups extends ConfigurationCoordinatingGroup implements IReturn<QueryConfigurationCoordinatingGroupsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationCoordinatingGroups>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationCoordinatingGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationCoordinatingGroupsResponse(); }
}

export class SaveConfigurationInstitution implements IReturn<SaveConfigurationInstitutionResponse>
{
    [immerable] = true;
    public data: ConfigurationInstitution;
    public allocations: ConfigurationSourceDataAllocation[];
    public participantSourceDataAllocationUpdates: ParticipantSourceDataAllocationUpdate[];

    public constructor(init?: Partial<SaveConfigurationInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveConfigurationInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveConfigurationInstitutionResponse(); }
}

export class QueryConfigurationInstitutions extends ConfigurationInstitution implements IReturn<QueryConfigurationInstitutionsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationInstitutions>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationInstitutions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationInstitutionsResponse(); }
}

export class SaveConfigurationMasterGroup implements IReturn<SaveConfigurationMasterGroupResponse>
{
    [immerable] = true;
    public data: ConfigurationMasterGroup;
    public allocations: ConfigurationSourceDataAllocation[];
    public participantSourceDataAllocationUpdates: ParticipantSourceDataAllocationUpdate[];

    public constructor(init?: Partial<SaveConfigurationMasterGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveConfigurationMasterGroup'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveConfigurationMasterGroupResponse(); }
}

export class QueryConfigurationMasterGroups extends ConfigurationMasterGroup implements IReturn<QueryConfigurationMasterGroupsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationMasterGroups>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationMasterGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationMasterGroupsResponse(); }
}

export class SaveConfigurationParticipant implements IReturn<SaveConfigurationParticipantResponse>
{
    [immerable] = true;
    public data: ConfigurationParticipant;
    public allocations: ConfigurationSourceDataAllocation[];
    public participantSourceDataAllocationUpdates: ParticipantSourceDataAllocationUpdate[];

    public constructor(init?: Partial<SaveConfigurationParticipant>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveConfigurationParticipant'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveConfigurationParticipantResponse(); }
}

export class QueryConfigurationParticipants extends ConfigurationParticipant implements IReturn<QueryConfigurationParticipantsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationParticipants>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationParticipants'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationParticipantsResponse(); }
}

export class QueryConfigurationSourceDataAllocations extends ConfigurationSourceDataAllocation implements IReturn<QueryConfigurationSourceDataAllocationsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationSourceDataAllocations>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationSourceDataAllocations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationSourceDataAllocationsResponse(); }
}

export class QueryConfigurationSourceDataEvents extends ConfigurationSourceDataEvent implements IReturn<QueryConfigurationSourceDataEventsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationSourceDataEvents>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationSourceDataEvents'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationSourceDataEventsResponse(); }
}

export class QueryConfigurationSourceDataForms extends ConfigurationSourceDataForm implements IReturn<QueryConfigurationSourceDataFormsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationSourceDataForms>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationSourceDataForms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationSourceDataFormsResponse(); }
}

export class QueryConfigurationSourceDataFormVersions extends ConfigurationSourceDataFormVersion implements IReturn<QueryConfigurationSourceDataFormVersionsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationSourceDataFormVersions>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationSourceDataFormVersions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationSourceDataFormVersionsResponse(); }
}

export class QueryConfigurationSourceDataItemGroups extends ConfigurationSourceDataItemGroup implements IReturn<QueryConfigurationSourceDataItemGroupsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationSourceDataItemGroups>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationSourceDataItemGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationSourceDataItemGroupsResponse(); }
}

export class QueryConfigurationSourceDataItems extends ConfigurationSourceDataItem implements IReturn<QueryConfigurationSourceDataItemsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationSourceDataItems>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationSourceDataItems'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationSourceDataItemsResponse(); }
}

export class QueryConfigurationSourceDataItemValues extends ConfigurationSourceDataItemValue implements IReturn<QueryConfigurationSourceDataItemValuesResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationSourceDataItemValues>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationSourceDataItemValues'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationSourceDataItemValuesResponse(); }
}

export class GetNewConfigurationSourceData implements IReturn<GetConfigurationSourceDataResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetNewConfigurationSourceData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNewConfigurationSourceData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConfigurationSourceDataResponse(); }
}

export class GetConfigurationSourceData implements IReturn<GetConfigurationSourceDataResponse>
{
    [immerable] = true;
    public trialId?: number;
    public configurationSourceDataId?: number;

    public constructor(init?: Partial<GetConfigurationSourceData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetConfigurationSourceData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConfigurationSourceDataResponse(); }
}

export class GetTrialConfigurationSourceData implements IReturn<GetConfigurationSourceDataResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetTrialConfigurationSourceData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialConfigurationSourceData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConfigurationSourceDataResponse(); }
}

export class SaveConfigurationSourceDataMap implements IReturn<GetConfigurationSourceDataResponse>
{
    [immerable] = true;
    public data: ConfigurationSourceDataMap;

    public constructor(init?: Partial<SaveConfigurationSourceDataMap>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveConfigurationSourceDataMap'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetConfigurationSourceDataResponse(); }
}

export class SaveConfigurationSourceData implements IReturn<SaveConfigurationSourceDataResponse>
{
    [immerable] = true;
    public data: ConfigurationSourceData;

    public constructor(init?: Partial<SaveConfigurationSourceData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveConfigurationSourceData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveConfigurationSourceDataResponse(); }
}

export class QueryConfigurationSourceDatas extends ConfigurationSourceData implements IReturn<QueryConfigurationSourceDatasResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationSourceDatas>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationSourceDatas'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationSourceDatasResponse(); }
}

export class SaveConfigurationTrial implements IReturn<SaveConfigurationTrialResponse>
{
    [immerable] = true;
    public data: ConfigurationTrial;
    public allocations: ConfigurationSourceDataAllocation[];
    public participantSourceDataAllocationUpdates: ParticipantSourceDataAllocationUpdate[];

    public constructor(init?: Partial<SaveConfigurationTrial>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveConfigurationTrial'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveConfigurationTrialResponse(); }
}

export class QueryConfigurationTrials extends ConfigurationTrial implements IReturn<QueryConfigurationTrialsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryConfigurationTrials>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryConfigurationTrials'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryConfigurationTrialsResponse(); }
}

export class QueryCoordinatingGroups extends CoordinatingGroup implements IReturn<QueryCoordinatingGroupsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryCoordinatingGroups>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryCoordinatingGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryCoordinatingGroupsResponse(); }
}

// @Route("/cached/metadata/{TrialId}")
export class CachedMetadata implements IReturn<GetMetadataResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<CachedMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CachedMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMetadataResponse(); }
}

// @Route("/cached/trial-configuration-source-data/{TrialId}/")
export class CachedTrialConfigurationSourceData implements IReturn<GetConfigurationSourceDataResponse>
{
    [immerable] = true;
    public trialId?: number;
    public configurationSourceDataId?: number;

    public constructor(init?: Partial<CachedTrialConfigurationSourceData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CachedTrialConfigurationSourceData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConfigurationSourceDataResponse(); }
}

// @Route("/cached/configuration-source-data/{TrialId}/{ConfigurationSourceDataId}")
export class CachedConfigurationSourceData implements IReturn<GetConfigurationSourceDataResponse>
{
    [immerable] = true;
    public trialId?: number;
    public configurationSourceDataId?: number;

    public constructor(init?: Partial<CachedConfigurationSourceData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CachedConfigurationSourceData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConfigurationSourceDataResponse(); }
}

export class QueryInstitutions extends Institution implements IReturn<QueryInstitutionsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryInstitutions>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryInstitutions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryInstitutionsResponse(); }
}

export class QueryMasterGroups extends MasterGroup implements IReturn<QueryMasterGroupsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryMasterGroups>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryMasterGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryMasterGroupsResponse(); }
}

export class QueryMetadataEventForms extends MetadataEventForm implements IReturn<QueryMetadataEventFormsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryMetadataEventForms>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryMetadataEventForms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryMetadataEventFormsResponse(); }
}

export class QueryMetadataEvents extends MetadataEvent implements IReturn<QueryMetadataEventsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryMetadataEvents>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryMetadataEvents'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryMetadataEventsResponse(); }
}

export class QueryMetadataForms extends MetadataForm implements IReturn<QueryMetadataFormsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryMetadataForms>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryMetadataForms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryMetadataFormsResponse(); }
}

export class QueryMetadataFormVersions extends MetadataFormVersion implements IReturn<QueryMetadataFormVersionsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryMetadataFormVersions>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryMetadataFormVersions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryMetadataFormVersionsResponse(); }
}

export class QueryMetadataItemGroups extends MetadataItemGroup implements IReturn<QueryMetadataItemGroupsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryMetadataItemGroups>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryMetadataItemGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryMetadataItemGroupsResponse(); }
}

export class QueryMetadataItems extends MetadataItem implements IReturn<QueryMetadataItemsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryMetadataItems>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryMetadataItems'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryMetadataItemsResponse(); }
}

export class QueryMetadataItemValues extends MetadataItemValue implements IReturn<QueryMetadataItemValuesResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryMetadataItemValues>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryMetadataItemValues'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryMetadataItemValuesResponse(); }
}

export class GetMetadata implements IReturn<GetMetadataResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMetadataResponse(); }
}

// @Route("/hello")
// @Route("/hello/{Name}")
export class Hello implements IReturn<HelloResponse>
{
    [immerable] = true;
    public name: string;

    public constructor(init?: Partial<Hello>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Hello'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HelloResponse(); }
}

export class TestCors implements IReturn<TestCorsResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<TestCors>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TestCors'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TestCorsResponse(); }
}

export class GetTrialNotes implements IReturn<GetNotesResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetTrialNotes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialNotes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNotesResponse(); }
}

export class GetMasterGroupNotes implements IReturn<GetNotesResponse>
{
    [immerable] = true;
    public masterGroupId?: number;

    public constructor(init?: Partial<GetMasterGroupNotes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMasterGroupNotes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNotesResponse(); }
}

export class GetCoordinatingGroupNotes implements IReturn<GetNotesResponse>
{
    [immerable] = true;
    public coordinatingGroupId?: number;

    public constructor(init?: Partial<GetCoordinatingGroupNotes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCoordinatingGroupNotes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNotesResponse(); }
}

export class GetInstitutionNotes implements IReturn<GetNotesResponse>
{
    [immerable] = true;
    public institutionId?: number;

    public constructor(init?: Partial<GetInstitutionNotes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionNotes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNotesResponse(); }
}

export class GetParticipantNotes implements IReturn<GetNotesResponse>
{
    [immerable] = true;
    public participantId?: number;

    public constructor(init?: Partial<GetParticipantNotes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetParticipantNotes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNotesResponse(); }
}

export class GetStudyEventNotes implements IReturn<GetNotesResponse>
{
    [immerable] = true;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;

    public constructor(init?: Partial<GetStudyEventNotes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStudyEventNotes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNotesResponse(); }
}

export class GetCaseReportFormNotes implements IReturn<GetNotesResponse>
{
    [immerable] = true;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<GetCaseReportFormNotes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCaseReportFormNotes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNotesResponse(); }
}

export class PostNoteAdd implements IReturn<NoteUpdateResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;
    public type?: NoteType;
    public title: string;
    public details: string;

    public constructor(init?: Partial<PostNoteAdd>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostNoteAdd'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new NoteUpdateResponse(); }
}

export class PostBulkNoteAdd implements IReturn<NoteUpdateResponse>
{
    [immerable] = true;
    public notes: PostNoteAdd[];

    public constructor(init?: Partial<PostBulkNoteAdd>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostBulkNoteAdd'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new NoteUpdateResponse(); }
}

export class PostNoteUpdate implements IReturn<NoteUpdateResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;
    public noteId?: number;
    public status?: NoteStatus;
    public title: string;
    public details: string;

    public constructor(init?: Partial<PostNoteUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostNoteUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new NoteUpdateResponse(); }
}

// @Route("/open-clinica/source-document")
export class GetOpenClinicaFile implements IReturn<Blob>
{
    [immerable] = true;
    public fileName: string;

    public constructor(init?: Partial<GetOpenClinicaFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOpenClinicaFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

export class QueryParticipants extends Participant implements IReturn<QueryParticipantsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryParticipants>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryParticipants'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryParticipantsResponse(); }
}

export class CalculateConfigurationTrialParticipantSourceDataAllocations implements IReturn<CalculateParticipantSourceDataAllocationsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public configurationTrial: ConfigurationTrial;
    public allocations: ConfigurationSourceDataAllocation[];

    public constructor(init?: Partial<CalculateConfigurationTrialParticipantSourceDataAllocations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CalculateConfigurationTrialParticipantSourceDataAllocations'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CalculateParticipantSourceDataAllocationsResponse(); }
}

export class CalculateConfigurationMasterGroupParticipantSourceDataAllocations implements IReturn<CalculateParticipantSourceDataAllocationsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public configurationMasterGroup: ConfigurationMasterGroup;
    public allocations: ConfigurationSourceDataAllocation[];

    public constructor(init?: Partial<CalculateConfigurationMasterGroupParticipantSourceDataAllocations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CalculateConfigurationMasterGroupParticipantSourceDataAllocations'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CalculateParticipantSourceDataAllocationsResponse(); }
}

export class CalculateConfigurationCoordinatingGroupParticipantSourceDataAllocations implements IReturn<CalculateParticipantSourceDataAllocationsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public configurationCoordinatingGroup: ConfigurationCoordinatingGroup;
    public allocations: ConfigurationSourceDataAllocation[];

    public constructor(init?: Partial<CalculateConfigurationCoordinatingGroupParticipantSourceDataAllocations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CalculateConfigurationCoordinatingGroupParticipantSourceDataAllocations'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CalculateParticipantSourceDataAllocationsResponse(); }
}

export class CalculateConfigurationInstitutionParticipantSourceDataAllocations implements IReturn<CalculateParticipantSourceDataAllocationsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public configurationInstitution: ConfigurationInstitution;
    public allocations: ConfigurationSourceDataAllocation[];

    public constructor(init?: Partial<CalculateConfigurationInstitutionParticipantSourceDataAllocations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CalculateConfigurationInstitutionParticipantSourceDataAllocations'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CalculateParticipantSourceDataAllocationsResponse(); }
}

export class CalculateConfigurationParticipantParticipantSourceDataAllocations implements IReturn<CalculateParticipantSourceDataAllocationsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public configurationParticipant: ConfigurationParticipant;
    public allocations: ConfigurationSourceDataAllocation[];

    public constructor(init?: Partial<CalculateConfigurationParticipantParticipantSourceDataAllocations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CalculateConfigurationParticipantParticipantSourceDataAllocations'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CalculateParticipantSourceDataAllocationsResponse(); }
}

export class QueryParticipantSourceDataAllocations extends ParticipantSourceDataAllocation implements IReturn<QueryParticipantSourceDataAllocationsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryParticipantSourceDataAllocations>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryParticipantSourceDataAllocations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryParticipantSourceDataAllocationsResponse(); }
}

export class JoinChannels implements IReturn<ChannelsResponse>
{
    [immerable] = true;
    public connectionId: string;
    public channels: string[];

    public constructor(init?: Partial<JoinChannels>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JoinChannels'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ChannelsResponse(); }
}

export class LeaveChannels implements IReturn<ChannelsResponse>
{
    [immerable] = true;
    public connectionId: string;
    public channels: string[];

    public constructor(init?: Partial<LeaveChannels>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LeaveChannels'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ChannelsResponse(); }
}

export class QuerySourceDataEvents implements IReturn<QuerySourceDataEventsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;

    public constructor(init?: Partial<QuerySourceDataEvents>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuerySourceDataEvents'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataEventsResponse(); }
}

export class GetTrialSourceDataFindings implements IReturn<GetSourceDataFindingsResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetTrialSourceDataFindings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialSourceDataFindings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataFindingsResponse(); }
}

export class GetMasterGroupSourceDataFindings implements IReturn<GetSourceDataFindingsResponse>
{
    [immerable] = true;
    public masterGroupId?: number;

    public constructor(init?: Partial<GetMasterGroupSourceDataFindings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMasterGroupSourceDataFindings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataFindingsResponse(); }
}

export class GetCoordinatingGroupSourceDataFindings implements IReturn<GetSourceDataFindingsResponse>
{
    [immerable] = true;
    public coordinatingGroupId?: number;

    public constructor(init?: Partial<GetCoordinatingGroupSourceDataFindings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCoordinatingGroupSourceDataFindings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataFindingsResponse(); }
}

export class GetInstitutionSourceDataFindings implements IReturn<GetSourceDataFindingsResponse>
{
    [immerable] = true;
    public institutionId?: number;

    public constructor(init?: Partial<GetInstitutionSourceDataFindings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionSourceDataFindings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataFindingsResponse(); }
}

export class GetParticipantSourceDataFindings implements IReturn<GetSourceDataFindingsResponse>
{
    [immerable] = true;
    public participantId?: number;

    public constructor(init?: Partial<GetParticipantSourceDataFindings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetParticipantSourceDataFindings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataFindingsResponse(); }
}

export class GetStudyEventSourceDataFindings implements IReturn<GetSourceDataFindingsResponse>
{
    [immerable] = true;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;

    public constructor(init?: Partial<GetStudyEventSourceDataFindings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStudyEventSourceDataFindings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataFindingsResponse(); }
}

export class GetCaseReportFormSourceDataFindings implements IReturn<GetSourceDataFindingsResponse>
{
    [immerable] = true;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<GetCaseReportFormSourceDataFindings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCaseReportFormSourceDataFindings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataFindingsResponse(); }
}

export class PostSourceDataFindingSave implements IReturn<PostSourceDataFindingSaveResponse>
{
    [immerable] = true;
    public data: SourceDataFinding;

    public constructor(init?: Partial<PostSourceDataFindingSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSourceDataFindingSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSourceDataFindingSaveResponse(); }
}

export class PostSourceDataFindingDelete implements IReturn<PostSourceDataFindingDeleteResponse>
{
    [immerable] = true;
    public data: SourceDataFinding;

    public constructor(init?: Partial<PostSourceDataFindingDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSourceDataFindingDelete'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSourceDataFindingDeleteResponse(); }
}

export class QuerySourceDataFindings extends SourceDataFinding implements IReturn<QuerySourceDataFindingsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QuerySourceDataFindings>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QuerySourceDataFindings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataFindingsResponse(); }
}

export class QuerySourceDataForms implements IReturn<QuerySourceDataFormsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<QuerySourceDataForms>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuerySourceDataForms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataFormsResponse(); }
}

export class GetSourceDataItemAudit implements IReturn<GetSourceDataItemAuditResponse>
{
    [immerable] = true;
    public trialId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;

    public constructor(init?: Partial<GetSourceDataItemAudit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataItemAudit'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataItemAuditResponse(); }
}

export class GetSourceDataReviewAudit implements IReturn<GetSourceDataReviewAuditResponse>
{
    [immerable] = true;
    public trialId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;

    public constructor(init?: Partial<GetSourceDataReviewAudit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataReviewAudit'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataReviewAuditResponse(); }
}

export class GetSourceDataVerificationAudit implements IReturn<GetSourceDataVerificationAuditResponse>
{
    [immerable] = true;
    public trialId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;

    public constructor(init?: Partial<GetSourceDataVerificationAudit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataVerificationAudit'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataVerificationAuditResponse(); }
}

export class QuerySourceDataItems implements IReturn<QuerySourceDataItemsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<QuerySourceDataItems>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuerySourceDataItems'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataItemsResponse(); }
}

export class GetSourceDataReport implements IReturn<GetSourceDataReportResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;
    public type?: SourceDataReportType;
    public enteredBy: string;
    public startDate?: string;
    public endDate?: string;
    public skip?: number;
    public take?: number;

    public constructor(init?: Partial<GetSourceDataReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataReportResponse(); }
}

export class GetSourceDataReportUsers implements IReturn<GetSourceDataReportUsersResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetSourceDataReportUsers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataReportUsers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSourceDataReportUsersResponse(); }
}

export class QuerySourceDatas implements IReturn<QuerySourceDatasResponse>
{
    [immerable] = true;
    public trialId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<QuerySourceDatas>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuerySourceDatas'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDatasResponse(); }
}

export class GetCaseReportFormState implements IReturn<GetCaseReportFormStateResponse>
{
    [immerable] = true;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<GetCaseReportFormState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCaseReportFormState'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCaseReportFormStateResponse(); }
}

export class UpdateSourceDataItemState implements IReturn<UpdateSourceDataItemStateResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public itemGroupName: string;
    public itemGroupRepeat?: number;
    public itemName: string;
    public value: string;
    public priority?: SourceDataPriority;
    public reviewed?: boolean;
    public verified?: boolean;

    public constructor(init?: Partial<UpdateSourceDataItemState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateSourceDataItemState'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateSourceDataItemStateResponse(); }
}

export class UpdateCaseReportFormState implements IReturn<UpdateCaseReportFormStateResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public caseReportFormVersionOid: string;
    public updates: SourceDataReviewAndVerificationUpdate[];

    public constructor(init?: Partial<UpdateCaseReportFormState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateCaseReportFormState'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateCaseReportFormStateResponse(); }
}

export class UpdateSourceDataReviewAndVerificationCounts implements IReturn<UpdateSourceDataReviewAndVerificationCountsResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;
    public updateReviewed?: boolean;
    public updateVerified?: boolean;

    public constructor(init?: Partial<UpdateSourceDataReviewAndVerificationCounts>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateSourceDataReviewAndVerificationCounts'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateSourceDataReviewAndVerificationCountsResponse(); }
}

export class GetTrialSourceDataStatuses implements IReturn<QuerySourceDataStatusesResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetTrialSourceDataStatuses>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialSourceDataStatuses'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataStatusesResponse(); }
}

export class GetInstitutionSourceDataStatuses implements IReturn<QuerySourceDataStatusesResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetInstitutionSourceDataStatuses>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionSourceDataStatuses'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataStatusesResponse(); }
}

export class GetParticipantSourceDataStatuses implements IReturn<QuerySourceDataStatusesResponse>
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetParticipantSourceDataStatuses>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetParticipantSourceDataStatuses'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataStatusesResponse(); }
}

export class GetEventSourceDataStatuses implements IReturn<QuerySourceDataStatusesResponse>
{
    [immerable] = true;
    public participantId?: number;

    public constructor(init?: Partial<GetEventSourceDataStatuses>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEventSourceDataStatuses'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataStatusesResponse(); }
}

export class GetFormSourceDataStatuses implements IReturn<QuerySourceDataStatusesResponse>
{
    [immerable] = true;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;

    public constructor(init?: Partial<GetFormSourceDataStatuses>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormSourceDataStatuses'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataStatusesResponse(); }
}

export class QuerySourceDataStatuses extends SourceDataStatus implements IReturn<QuerySourceDataStatusesResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QuerySourceDataStatuses>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QuerySourceDataStatuses'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySourceDataStatusesResponse(); }
}

export class QueueStatus implements IReturn<UpdateStatusResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<QueueStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateStatusResponse(); }
}

export class UpdateStatus implements IReturn<UpdateStatusResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<UpdateStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateStatusResponse(); }
}

export class QueueLockedEventStatus implements IReturn<UpdateStatusResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<QueueLockedEventStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueLockedEventStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateStatusResponse(); }
}

export class UpdateLockedEventStatus implements IReturn<UpdateStatusResponse>
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public participantId?: number;
    public studyEventOid: string;
    public studyEventRepeat?: number;
    public caseReportFormOid: string;

    public constructor(init?: Partial<UpdateLockedEventStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateLockedEventStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateStatusResponse(); }
}

// @Route("/todos", "GET")
export class QueryTodos extends QueryData<Todo> implements IReturn<QueryResponse<Todo>>
{
    [immerable] = true;
    public id?: number;
    public ids: number[];
    public textContains: string;

    public constructor(init?: Partial<QueryTodos>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryTodos'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryResponse<Todo>(); }
}

// @Route("/todos", "POST")
export class CreateTodo implements IReturn<Todo>, IPost
{
    [immerable] = true;
    // @Validate(Validator="NotEmpty")
    public text: string;

    public constructor(init?: Partial<CreateTodo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTodo'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Todo(); }
}

// @Route("/todos/{Id}", "PUT")
export class UpdateTodo implements IReturn<Todo>, IPut
{
    [immerable] = true;
    public id: number;
    // @Validate(Validator="NotEmpty")
    public text: string;

    public isFinished: boolean;

    public constructor(init?: Partial<UpdateTodo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateTodo'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new Todo(); }
}

// @Route("/todos/{Id}", "DELETE")
export class DeleteTodo implements IReturnVoid, IDelete
{
    [immerable] = true;
    public id: number;

    public constructor(init?: Partial<DeleteTodo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTodo'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() {}
}

// @Route("/todos", "DELETE")
export class DeleteTodos implements IReturnVoid, IDelete
{
    [immerable] = true;
    public ids: number[] = [];

    public constructor(init?: Partial<DeleteTodos>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTodos'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() {}
}

export class QueryTrials extends Trial implements IReturn<QueryTrialsResponse>, IQueryDataRequest
{
    [immerable] = true;

    public constructor(init?: Partial<QueryTrials>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryTrials'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryTrialsResponse(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable] = true;
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    [immerable] = true;
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

